import { CMSPath } from '../../config/constant'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setSubmitRequestWindow, setRequestIDList } from "../../action/guestRequest"
import { popupOpenClose } from '../../action/action'
import defaultImg from '../../images/icon/guest_services.svg'
import { guestRequestButton } from '../../JS/setColors'

class GuestRequestList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedList: [],
        }
    }

    componentDidMount() {
        guestRequestButton(this.props.menuColor);
    }

    addToSelectList = (id) => {
        //console.log("addToSelectList");
        let selectedList = [...this.state.selectedList]
        if (selectedList.indexOf(id) !== -1) {
            selectedList.splice(selectedList.indexOf(id), 1);
        } else {
            selectedList.push(id);
        }
        this.setState({ selectedList: selectedList });
    }

    SubmitToForm = () => {
        if (this.state.selectedList.length > 0) {
            this.props.setRequestIDList(this.state.selectedList);
            this.props.setSubmitRequestWindow(true);
            this.setState({ selectedList: [] });
        } else {
            this.props.popupOpenClose(true, "Please select your request.");
        }
    }

    render() {
        return (
            <div id="gs-list" className="col h-100 results-col" style={{ background: "rgba(255,255,255,0.95)", color: "inherit" }}>
                <div id="gs-room" className="rc-controls w-100" style={{ color: "inherit" }}>
                    <div className="activity-heading all-caps" style={{ color: "inherit" }}>{this.props.displayName}</div>
                    {
                        this.props.guestRequestList &&
                            this.props.guestRequestList.length > 0 ?
                            this.props.guestRequestList.map((iterator, index) => {
                                return (
                                    <button
                                        className={
                                            this.state.selectedList.length > 0 &&
                                                this.state.selectedList.indexOf(iterator.serviceRequestId) !== -1 ?
                                                `button button-thumb selected`
                                                : `button button-thumb`
                                        }
                                        style={{
                                            backgroundImage: `url("${CMSPath}${this.props.imageBaseUrl}${iterator.imageName}")`,
                                            backgroundSize: "cover"
                                        }}
                                        onClick={() => { this.addToSelectList(iterator.serviceRequestId) }}
                                    >
                                        <img src={defaultImg} style={iterator.imageName ? { display: "none" } : {}} />
                                        <span
                                            className="button-thumb-text"
                                            style={{ color: "#fff" }}
                                        >
                                            {iterator.name}
                                        </span>
                                    </button>
                                )
                            })
                            : null
                    }
                </div>
                <div className="sticky bottom">
                    <button id="GuestRequestSubmitForm" className="w-100" onClick={this.SubmitToForm}>Submit</button>
                </div>
            </div >
        )
    }
}

const mapStateToProps = state => {
    return {
        stringConst: state.store.home.stringConst,
        guestRequestList: state.store.guestRequest.guestRequestList,
        imageBaseUrl: state.store.guestRequest.guestRequestOtherData ?
            state.store.guestRequest.guestRequestOtherData.imageBaseUrl : null,
        menuColor: state.store.home.MenuColor,
        displayName: state.store.sideNavBar.currentWidget.displayName
    }
}
export default connect(
    mapStateToProps,
    {

        setSubmitRequestWindow,
        popupOpenClose,
        setRequestIDList
    }
)(GuestRequestList);